import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

import { FolderFragmentDoc } from '../fragments.generated';

const defaultOptions = {} as const;
export type AncestorFoldersQueryVariables = Types.Exact<{
  inputs: Types.GetFoldersInputs;
}>;

export type AncestorFoldersQuery = {
  __typename?: 'Query';
  ancestorFolders?: Array<{
    __typename?: 'AncestorFolder';
    id: string;
    name: string;
    sequence: number;
  }> | null;
};

export type FolderQueryVariables = Types.Exact<{
  inputs: Types.GetFoldersInputs;
}>;

export type FolderQuery = {
  __typename?: 'Query';
  folder?: {
    __typename?: 'Folder';
    id: string;
    driveId?: string | null;
    name: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    creatorId: string;
    projectCount: number;
    folderCount: number;
  } | null;
};

export type FoldersQueryVariables = Types.Exact<{
  inputs: Types.FolderInputs;
}>;

export type FoldersQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    folders?: Array<{
      __typename?: 'Folder';
      id: string;
      driveId?: string | null;
      name: string;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
      creatorId: string;
      projectCount: number;
      folderCount: number;
    }> | null;
  };
};

export type CreateFolderMutationVariables = Types.Exact<{
  inputs: Types.CreateFolderInputs;
}>;

export type CreateFolderMutation = {
  __typename?: 'Mutation';
  createFolder: {
    __typename?: 'CreateFolderMutationResponse';
    code: string;
    success: boolean;
    message: string;
    folder?: {
      __typename?: 'Folder';
      id: string;
      driveId?: string | null;
      name: string;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
      creatorId: string;
      projectCount: number;
      folderCount: number;
    } | null;
  };
};

export type MoveFolderMutationVariables = Types.Exact<{
  inputs: Types.MoveFolderInputs;
}>;

export type MoveFolderMutation = {
  __typename?: 'Mutation';
  moveFolder: {
    __typename?: 'MoveFolderMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type MoveFilesMutationVariables = Types.Exact<{
  inputs: Types.MoveFilesInputs;
}>;

export type MoveFilesMutation = {
  __typename?: 'Mutation';
  moveFiles: {
    __typename?: 'MoveFilesMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type DeleteFolderMutationVariables = Types.Exact<{
  inputs: Types.DeleteFolderInputs;
}>;

export type DeleteFolderMutation = {
  __typename?: 'Mutation';
  deleteFolder: {
    __typename?: 'DeleteFolderMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type RenameFolderMutationVariables = Types.Exact<{
  inputs: Types.RenameFolderInputs;
}>;

export type RenameFolderMutation = {
  __typename?: 'Mutation';
  renameFolder: {
    __typename?: 'RenameFolderMutationResponse';
    code: string;
    success: boolean;
    message: string;
    folder?: {
      __typename?: 'Folder';
      id: string;
      driveId?: string | null;
      name: string;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
      creatorId: string;
      projectCount: number;
      folderCount: number;
    } | null;
  };
};

export const AncestorFoldersDocument = gql`
  query AncestorFolders($inputs: GetFoldersInputs!) {
    ancestorFolders(inputs: $inputs) {
      id
      name
      sequence
    }
  }
`;

/**
 * __useAncestorFoldersQuery__
 *
 * To run a query within a React component, call `useAncestorFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAncestorFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAncestorFoldersQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAncestorFoldersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AncestorFoldersQuery,
    AncestorFoldersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AncestorFoldersQuery, AncestorFoldersQueryVariables>(
    AncestorFoldersDocument,
    options
  );
}
export function useAncestorFoldersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AncestorFoldersQuery,
    AncestorFoldersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AncestorFoldersQuery, AncestorFoldersQueryVariables>(
    AncestorFoldersDocument,
    options
  );
}
export type AncestorFoldersQueryHookResult = ReturnType<typeof useAncestorFoldersQuery>;
export type AncestorFoldersLazyQueryHookResult = ReturnType<
  typeof useAncestorFoldersLazyQuery
>;
export type AncestorFoldersQueryResult = Apollo.QueryResult<
  AncestorFoldersQuery,
  AncestorFoldersQueryVariables
>;
export const FolderDocument = gql`
  query Folder($inputs: GetFoldersInputs!) {
    folder(inputs: $inputs) {
      ...FolderFragment
    }
  }
  ${FolderFragmentDoc}
`;

/**
 * __useFolderQuery__
 *
 * To run a query within a React component, call `useFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useFolderQuery(
  baseOptions: Apollo.QueryHookOptions<FolderQuery, FolderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FolderQuery, FolderQueryVariables>(FolderDocument, options);
}
export function useFolderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FolderQuery, FolderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FolderQuery, FolderQueryVariables>(FolderDocument, options);
}
export type FolderQueryHookResult = ReturnType<typeof useFolderQuery>;
export type FolderLazyQueryHookResult = ReturnType<typeof useFolderLazyQuery>;
export type FolderQueryResult = Apollo.QueryResult<FolderQuery, FolderQueryVariables>;
export const FoldersDocument = gql`
  query Folders($inputs: FolderInputs!) {
    user {
      id
      folders(inputs: $inputs) {
        ...FolderFragment
      }
    }
  }
  ${FolderFragmentDoc}
`;

/**
 * __useFoldersQuery__
 *
 * To run a query within a React component, call `useFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useFoldersQuery(
  baseOptions: Apollo.QueryHookOptions<FoldersQuery, FoldersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoldersQuery, FoldersQueryVariables>(FoldersDocument, options);
}
export function useFoldersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FoldersQuery, FoldersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FoldersQuery, FoldersQueryVariables>(
    FoldersDocument,
    options
  );
}
export type FoldersQueryHookResult = ReturnType<typeof useFoldersQuery>;
export type FoldersLazyQueryHookResult = ReturnType<typeof useFoldersLazyQuery>;
export type FoldersQueryResult = Apollo.QueryResult<FoldersQuery, FoldersQueryVariables>;
export const CreateFolderDocument = gql`
  mutation createFolder($inputs: CreateFolderInputs!) {
    createFolder(inputs: $inputs) {
      code
      success
      message
      folder {
        ...FolderFragment
      }
    }
  }
  ${FolderFragmentDoc}
`;
export type CreateFolderMutationFn = Apollo.MutationFunction<
  CreateFolderMutation,
  CreateFolderMutationVariables
>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFolderMutation,
    CreateFolderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(
    CreateFolderDocument,
    options
  );
}
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<
  CreateFolderMutation,
  CreateFolderMutationVariables
>;
export const MoveFolderDocument = gql`
  mutation moveFolder($inputs: MoveFolderInputs!) {
    moveFolder(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MoveFolderMutationFn = Apollo.MutationFunction<
  MoveFolderMutation,
  MoveFolderMutationVariables
>;

/**
 * __useMoveFolderMutation__
 *
 * To run a mutation, you first call `useMoveFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFolderMutation, { data, loading, error }] = useMoveFolderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMoveFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveFolderMutation,
    MoveFolderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveFolderMutation, MoveFolderMutationVariables>(
    MoveFolderDocument,
    options
  );
}
export type MoveFolderMutationHookResult = ReturnType<typeof useMoveFolderMutation>;
export type MoveFolderMutationResult = Apollo.MutationResult<MoveFolderMutation>;
export type MoveFolderMutationOptions = Apollo.BaseMutationOptions<
  MoveFolderMutation,
  MoveFolderMutationVariables
>;
export const MoveFilesDocument = gql`
  mutation moveFiles($inputs: MoveFilesInputs!) {
    moveFiles(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MoveFilesMutationFn = Apollo.MutationFunction<
  MoveFilesMutation,
  MoveFilesMutationVariables
>;

/**
 * __useMoveFilesMutation__
 *
 * To run a mutation, you first call `useMoveFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFilesMutation, { data, loading, error }] = useMoveFilesMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMoveFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<MoveFilesMutation, MoveFilesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveFilesMutation, MoveFilesMutationVariables>(
    MoveFilesDocument,
    options
  );
}
export type MoveFilesMutationHookResult = ReturnType<typeof useMoveFilesMutation>;
export type MoveFilesMutationResult = Apollo.MutationResult<MoveFilesMutation>;
export type MoveFilesMutationOptions = Apollo.BaseMutationOptions<
  MoveFilesMutation,
  MoveFilesMutationVariables
>;
export const DeleteFolderDocument = gql`
  mutation deleteFolder($inputs: DeleteFolderInputs!) {
    deleteFolder(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type DeleteFolderMutationFn = Apollo.MutationFunction<
  DeleteFolderMutation,
  DeleteFolderMutationVariables
>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDeleteFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFolderMutation,
    DeleteFolderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(
    DeleteFolderDocument,
    options
  );
}
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<
  DeleteFolderMutation,
  DeleteFolderMutationVariables
>;
export const RenameFolderDocument = gql`
  mutation renameFolder($inputs: RenameFolderInputs!) {
    renameFolder(inputs: $inputs) {
      code
      success
      message
      folder {
        ...FolderFragment
      }
    }
  }
  ${FolderFragmentDoc}
`;
export type RenameFolderMutationFn = Apollo.MutationFunction<
  RenameFolderMutation,
  RenameFolderMutationVariables
>;

/**
 * __useRenameFolderMutation__
 *
 * To run a mutation, you first call `useRenameFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFolderMutation, { data, loading, error }] = useRenameFolderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRenameFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameFolderMutation,
    RenameFolderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenameFolderMutation, RenameFolderMutationVariables>(
    RenameFolderDocument,
    options
  );
}
export type RenameFolderMutationHookResult = ReturnType<typeof useRenameFolderMutation>;
export type RenameFolderMutationResult = Apollo.MutationResult<RenameFolderMutation>;
export type RenameFolderMutationOptions = Apollo.BaseMutationOptions<
  RenameFolderMutation,
  RenameFolderMutationVariables
>;
